import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { ModalEl } from "common/components/modal";
import fyt from "./fyt.png";
export function template() {
  return /* @__PURE__ */ jsx(
    ModalEl,
    {
      sel: ".fyt-modal",
      attrs: { elref: `fyt-modal`, open: true, closeable: true },
      on: { change: this.handleFYTModalStateChanged }
    },
    /* @__PURE__ */ jsx("div", { sel: ".fyt-modal-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".fyt-modal-body.wider" }, /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".fyt-modal-pre-title" }, "Find Your Organization"), /* @__PURE__ */ jsx("div", { sel: ".fyt-modal-title" }, "A faster way to get all your teammates into Mixpanel"), /* @__PURE__ */ jsx("div", null, "Find Your Organization lets you make your organization searchable, joinable or undiscoverable to new users with your shared email domain."), /* @__PURE__ */ jsx("br", null), /* @__PURE__ */ jsx("div", null, "By default, team members can now join your org by request. You can modify these settings at any time."), /* @__PURE__ */ jsx("br", null)), /* @__PURE__ */ jsx(ButtonEl, { attrs: { theme: ButtonTheme.Primary }, on: { click: this.handleEditDiscoverabilityButtonClicked } }, "Edit Discoverability")), /* @__PURE__ */ jsx("img", { sel: ".fyt-image", attrs: { src: fyt } }))
  );
}
